// NOTE: This is copied from https://github.com/sindresorhus/auto-bind
// We've added one little guard clause because we have a funky situation with dateRange: sometimes it's a fn & sometimes a prop.

// Gets all non-builtin properties up the prototype chain.
const getAllProperties = object => {
	const properties = new Set()

	do {
		for (const key of Reflect.ownKeys(object)) {
			properties.add([object, key])
		}
	} while ((object = Reflect.getPrototypeOf(object)) && object !== Object.prototype)

	return properties
}

const bindableMethodsCache = new WeakMap()

const getBindableMethods = self => {
	const constructor = self.constructor
	let methods = bindableMethodsCache.get(constructor)
	if (methods) return methods

	// Method discovery is class-level metadata; only the actual binding is instance-specific.
	methods = []
	for (const [object, key] of getAllProperties(constructor.prototype)) {
		if (key === 'constructor') continue
		const descriptor = Reflect.getOwnPropertyDescriptor(object, key)
		if (descriptor && typeof descriptor.value === 'function') methods.push(key)
	}
	bindableMethodsCache.set(constructor, methods)
	return methods
}

export default function autoBind(self, {include, exclude} = {}) {
	const filter = key => {
		const match = pattern => (typeof pattern === 'string' ? key === pattern : pattern.test(key))

		if (include) return include.some(match)

		if (exclude) return !exclude.some(match)

		return true
	}

	for (const key of getBindableMethods(self)) {
		if (!filter(key)) continue
		if (self[key].bind) {
			//  we added this, due to dateRange sometimes being a fn & sometimes a property
			self[key] = self[key].bind(self)
		}
	}

	return self
}
